export const CommonUploadType = {
  avatars: 'avatars',
  brandingImages: 'brandingImages',
  articleImages: 'articleImages',
} as const;
